import { CollectionViewer,DataSource} from '@angular/cdk/collections';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
export class UsersDataSource implements DataSource<any>{
  private usersSubject=new BehaviorSubject<any>([])
  private usersLoadingSubject=new BehaviorSubject<boolean>(false)
  isLoading=this.usersLoadingSubject.asObservable()
  totalUsers=0
  constructor(private authService:AuthService){}
  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.usersSubject.asObservable()
  }
  disconnect(collectionViewer: CollectionViewer): void {
    this.usersSubject.complete()
    this.usersLoadingSubject.complete()
  }
  listallUsersWithinOrg(orgId,pageNumber,pageSize,sortField,sortType,username,status) {
    this.usersLoadingSubject.next(true)
    this.authService.listallUsersWithinOrg(orgId,pageNumber,pageSize,sortField,sortType,username,status)
    .pipe(
      catchError(()=>of([])),
      finalize(()=>this.usersLoadingSubject.next(false))
    )
    .subscribe((res:any) => {
      this.totalUsers=res.totalUsers
      this.usersSubject.next(res.data)
    })
  }
}
